/**
 * 英語の序数変換（1st, 2nd, 3rd, 4th, ...）
 *
 * 変換ルール:
 * - 11, 12, 13 は例外的に "th" を使用
 * - それ以外は下1桁に応じて "st", "nd", "rd", "th" を決定
 *   - 1 -> st
 *   - 2 -> nd
 *   - 3 -> rd
 *   - その他 -> th
 *
 * @param num - 変換する数値
 * @returns 序数形式の文字列（例: "1st", "2nd", "3rd", "4th"）
 */
export const toOrdinal = (num: number): string => {
  const lastDigit = num % 10;
  const lastTwoDigits = num % 100;

  // 11, 12, 13 は例外的に 'th'
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return `${num}th`;
  }

  switch (lastDigit) {
    case 1:
      return `${num}st`;
    case 2:
      return `${num}nd`;
    case 3:
      return `${num}rd`;
    default:
      return `${num}th`;
  }
};
